import styles from './g2-badges.css?url'
export const links = () => [{ rel: 'stylesheet', href: styles }]
export { G2Badges } from './g2-badges'
